import styled from 'styled-components';

export const Space = styled.div`
  width: 100%;
  display: block;
  margin-bottom: 1em;
`;
